import { Box, Typography } from '@mui/material';
import colors from '../../../../assets/theme/base/colors';
import { SubHeading } from './TargetSettingsLabels';

interface IProps {
	qualifyingDate: string;
}

export const RulesInEffectPanel = ({ qualifyingDate }: IProps) => (
	<Box
		sx={{
			mt: 3,
			border: '1px solid',
			borderColor: colors.ui.border,
			borderRadius: 1,
			bgcolor: colors.empowermentFinancing.sectionHeaderBackground,
			p: 2,
		}}
	>
		<SubHeading sx={{ mb: 1 }}>Rules in effect</SubHeading>
		<Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, flexWrap: 'wrap' }}>
			<Typography variant="caption" sx={{ color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
				Transaction Qualification Threshold
			</Typography>
			<Typography variant="body2" sx={{ fontWeight: 700, color: 'primary.main' }}>
				{new Date(qualifyingDate).toLocaleDateString('en-ZA', { day: '2-digit', month: 'short', year: 'numeric' })}
			</Typography>
		</Box>
		<Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5 }}>
			Applies to Transformational Infrastructure, Agriculture Financing and Affordable Housing. Transactions disbursed
			before this date qualify only via a top-up on or after it.
		</Typography>
		<Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5, fontStyle: 'italic' }}>
			Carve-outs: Black Transactional Financing (pre-1 Dec 2017 window) and BBGF (Category-Type date rules) are
			unaffected by the period selection.
		</Typography>
	</Box>
);
